/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u5m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Common prompts are three things you're grateful for, one thing you're avoiding, or a quick brain dump of whatever's on your mind. Five minutes is enough for a few honest sentences without turning it into a long writing task you'll skip on busy days.`)
};

const es_timer_u5m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las indicaciones habituales son tres cosas por las que estás agradecido, algo que estás evitando, o un volcado rápido de lo que tienes en mente. Cinco minutos son suficientes para unas frases honestas sin convertirlo en una tarea de escritura larga que evitarás en los días ocupados.`)
};

const de_timer_u5m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gängige Impulse sind drei Dinge, für die du dankbar bist, eine Sache, die du vermeidest, oder ein schneller Gedanken-Dump von allem, was dich beschäftigt. Fünf Minuten reichen für ein paar ehrliche Sätze, ohne dass daraus eine lange Schreibaufgabe wird, die du an vollen Tagen ausfallen lässt.`)
};

const nl_timer_u5m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veelgebruikte prompts zijn drie dingen waar je dankbaar voor bent, één ding dat je vermijdt, of een snelle braindump van wat er in je hoofd zit. Vijf minuten is genoeg voor een paar eerlijke zinnen, zonder dat het een lange schrijftaak wordt die je op drukke dagen overslaat.`)
};

const fr_timer_u5m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les incitations courantes sont trois choses pour lesquelles vous êtes reconnaissant, une chose que vous évitez, ou un déversement rapide de ce qui vous préoccupe. Cinq minutes suffisent pour quelques phrases sincères, sans en faire une longue tâche d’écriture que vous éviterez les jours chargés.`)
};

const it_timer_u5m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spunti comuni sono tre cose per cui sei grato, una cosa che stai evitando, o uno sfogo rapido di tutto ciò che hai in mente. Cinque minuti bastano per qualche frase sincera senza trasformarlo in un lungo compito di scrittura che salterai nei giorni impegnativi.`)
};

const pt_br2_timer_u5m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugestões comuns incluem três coisas pelas quais você é grato, uma coisa que você está evitando, ou um despejo rápido de tudo o que está na sua cabeça. Cinco minutos são suficientes para algumas frases honestas sem transformar isso em uma tarefa longa de escrita que você vai pular em dias corridos.`)
};

const pt_timer_u5m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugestões comuns são três coisas pelas quais é grato, uma coisa que está a evitar, ou um rápido despejo mental de tudo o que lhe vai na cabeça. Cinco minutos são suficientes para algumas frases honestas, sem transformar isto numa tarefa de escrita longa que vai saltar nos dias mais atarefados.`)
};

const ja_timer_u5m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`よくあるお題は、感謝していること3つ、避けていること1つ、または頭に浮かんだことをそのまま書き出す簡単なブレインダンプです。5分あれば数文の率直な内容を書くには十分で、忙しい日に飛ばしてしまうような長い執筆タスクにはなりません。`)
};

const zh_timer_u5m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`常见的提示是写下三件你感激的事、一件你在逃避的事，或把脑海中的想法快速倾倒出来。五分钟足够写出几句真实的话，又不会变成一项漫长的写作任务，让你在忙碌的日子里干脆跳过。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u5m_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u5m_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u5m_faq4_a", locale)
	if (locale === "en") return en_timer_u5m_faq4_a(inputs)
	if (locale === "es") return es_timer_u5m_faq4_a(inputs)
	if (locale === "de") return de_timer_u5m_faq4_a(inputs)
	if (locale === "nl") return nl_timer_u5m_faq4_a(inputs)
	if (locale === "fr") return fr_timer_u5m_faq4_a(inputs)
	if (locale === "it") return it_timer_u5m_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u5m_faq4_a(inputs)
	if (locale === "pt") return pt_timer_u5m_faq4_a(inputs)
	if (locale === "ja") return ja_timer_u5m_faq4_a(inputs)
	return zh_timer_u5m_faq4_a(inputs)
};